import React from "react";
import "./palam_sensor_dock.scss";
import PalamButtonBigRound from "./palam_button_big_round";

class PalamSensorDock extends React.PureComponent {
  render() {
    let { size, onMouseUp, acceptsDrop } = this.props;
    let color = acceptsDrop ? "#4caf50" : "red";
    return (
      <div>
      <PalamButtonBigRound label="" size={size} onMouseUp={onMouseUp} color={color}>
        <PalamSensorDockInner acceptsDrop/>
      </PalamButtonBigRound>
      <span className="palam-sensor-dock-label">Drop To connect</span>
      </div>
    );
  }
}

export default PalamSensorDock;

class PalamSensorDockInner extends React.PureComponent {
  render() {
    let {acceptsDrop} = this.props;
    return <div className="palam-sensor-dock-inner" style={{backgroundColor: acceptsDrop?"#4caf50":""}}></div>;
  }
}
